import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Ya intenté cosas y no funcionaron. ¿Por qué esto sería diferente?',
    a: 'Lo que probaste antes probablemente atacaba el síntoma — la conducta — sin tocar la estructura emocional que la mantiene activa. El Ciclo P-C-V trabaja en el mecanismo real: el bucle neuroemocional. Eso es lo que hace la diferencia.'
  }, {
    q: '¿Cuánto tiempo al día necesito?',
    a: 'Las prácticas están diseñadas para 5 a 15 minutos diarios. No requieren equipos, espacio especial, ni que nadie más lo sepa. Si tienes tiempo para el ciclo, tienes tiempo para interrumpirlo.'
  }, {
    q: '¿Esto reemplaza la terapia?',
    a: 'No reemplaza la terapia — la complementa. Pero funciona de manera independiente para quien no tiene acceso a terapia en este momento, o prefiere trabajar su proceso de forma privada. Nota: si estás en una situación de crisis, busca atención clínica primero.'
  }, {
    q: '¿Y si recaigo durante los 21 días?',
    a: 'El sistema lo contempla. No es una promesa de perfección — es un proceso de redirección progresiva. Una recaída durante el proceso no borra el trabajo hecho. Es información, no fracaso.'
  }, {
    q: '¿Funciona para cualquier tipo de adicción o compulsión?',
    a: 'Si reconoces el Ciclo P-C-V en tu experiencia — independientemente de cuál sea la conducta — el sistema está diseñado para ti. El mecanismo emocional es el mismo en la mayoría de las adicciones y compulsiones.'
  }, {
    q: '¿El material completo en qué formato viene?',
    a: 'Sí, todo el material completo viene en formato digital PDF. Llega vía correo electrónico inmediatamente después de la compra — post compra, sin esperas.'
  }];
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_left,rgba(107,0,182,0.1)_0%,transparent_60%),var(--dark-bg)]" data-id="element-25">
      <div className="max-w-[900px] mx-auto" data-id="element-26">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-27">
          Preguntas frecuentes
        </span>

        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-28">
          Lo que quizás
          <br data-id="element-29" />
          <span className="text-gradient-magenta" data-id="element-30">te estás preguntando</span>
        </h2>

        <div className="mt-4 space-y-2" data-id="element-31">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-[rgba(107,0,182,0.08)] border rounded-[14px] overflow-hidden transition-all duration-300 ${isOpen ? 'border-[rgba(194,0,111,0.4)]' : 'border-[rgba(107,0,182,0.25)] hover:border-[rgba(194,0,111,0.4)]'}`} data-id="element-32">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full bg-transparent border-none text-white font-heading font-bold text-[0.95rem] text-left py-3.5 px-5 cursor-pointer flex justify-between items-center gap-4" data-id="element-33">
                  {faq.q}
                  <span className={`text-magenta-bright text-[1.4rem] shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45' : 'rotate-0'}`} data-id="element-34">
                    +
                  </span>
                </button>

                <AnimatePresence data-id="element-35">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-36">
                      <div className="px-5 pb-3.5 text-[0.92rem] leading-[1.6] text-white/75" data-id="element-37">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}